export { Table as AlertsTable } from './Table';
